import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { FormInput, FormSection } from '@/components';
import { useThemedStyles } from '@/hooks/shared/useThemeColors';

interface UserAccountInfoSectionProps {
  formData: {
    firstName: string;
    lastName: string;
    email: string;
  };
  errors: Record<string, string>;
  onFieldChange: (field: string, value: string) => void;
  isEditMode?: boolean;
}

export const UserAccountInfoSection: React.FC<UserAccountInfoSectionProps> = ({
  formData,
  errors,
  onFieldChange,
  isEditMode = false,
}) => {
  const styles = useStyles();
  return (
    <>
      {/* Step Indicator */}
      <View style={styles.stepIndicator}>
        <Text style={styles.stepText}>
          Step 1 of 3: {isEditMode ? 'Edit Account' : 'Create Account'}
        </Text>
      </View>

      <FormSection
        title="User Information"
        subtitle="Enter the basic information for the new user"
      >
        <View style={styles.container}>
          <FormInput
            label="First Name"
            value={formData.firstName}
            onChangeText={(value) => onFieldChange('firstName', value)}
            placeholder="Enter first name"
            error={errors.firstName}
            required
            autoCapitalize="words"
            autoCorrect={false}
          />

          <FormInput
            label="Last Name"
            value={formData.lastName}
            onChangeText={(value) => onFieldChange('lastName', value)}
            placeholder="Enter last name"
            error={errors.lastName}
            required
            autoCapitalize="words"
            autoCorrect={false}
          />

          <FormInput
            label="Email Address"
            value={formData.email}
            onChangeText={(value) => onFieldChange('email', value)}
            placeholder="Enter email address"
            error={errors.email}
            required
            keyboardType="email-address"
            autoCapitalize="none"
            autoCorrect={false}
          />
        </View>
      </FormSection>
    </>
  );
};

const useStyles = () =>
  useThemedStyles(({ components }) =>
    StyleSheet.create({
      stepIndicator: {
        backgroundColor: 'transparent',
        paddingHorizontal: 16,
        paddingVertical: 12,
        borderBottomWidth: 1,
        borderBottomColor: components.admin.dataTable.border,
        marginBottom: 16,
      },
      stepText: {
        fontSize: 14,
        fontWeight: '500',
        color: components.admin.dataCell.textMuted,
        textAlign: 'center',
      },
      container: {
        gap: 16,
      },
    }),
  );
